import { Injectable, signal, type WritableSignal } from '@angular/core';

/**
 * From this width up the open feed sits beside the page; below it the feed floats over
 * the page. Keep in sync with drive-conversation-host's `$overlay-below` and
 * child-layout's `$drive-feed-overlay-below` (and @mtm/drive's own feed sheet breakpoint).
 */
const FEED_BESIDE_PAGE_QUERY = '(min-width: 845px)';

/** The open feed would sit beside the page right now, rather than float over (and hide) it. */
export const feedBesidePage = (): boolean => window.matchMedia(FEED_BESIDE_PAGE_QUERY).matches;

/**
 * Shared UI state for the org-level drive comment shell (brand / drive-mode
 * workspace / campaign chat). The shell writes the rail's open state; child-layout
 * reads it to pad the content column, mirroring `DriveCommentPanelService` for the
 * drive project surface. Root-scoped because the shell is lazily deferred while
 * child-layout is eager.
 */
@Injectable({ providedIn: 'root' })
export class DriveOrgCommentsUiService {
  /** Drive's default is open, except where the feed would float over (and hide) the page. */
  readonly openByDefault = (): boolean => feedBesidePage();

  /** Whether the comment rail is open. */
  readonly open: WritableSignal<boolean> = signal(this.openByDefault());
}
